module.exports = __webpack_public_path__ + "dist/img/logo.d2e5de1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 1